import flux from "@aust/react-flux";

flux.dispatch('version/add',{"major":8,"minor":11})
flux.dispatch('version/add',{"major":8,"minor":12})
flux.dispatch('version/add',{"major":8,"minor":17})
flux.dispatch('version/add',{"major":9,"minor":5})
flux.dispatch('version/add',{"major":10,"minor":0})
flux.dispatch('version/add',{"major":10,"minor":8})
flux.dispatch('version/add',{"major":11,"minor":0})
flux.dispatch('version/add',{"major":11,"minor":11})
flux.dispatch('version/add',{"major":12,"minor":0})
flux.dispatch('version/add',{"major":12,"minor":1})
flux.dispatch('version/add',{"major":12,"minor":10})
flux.dispatch('version/add',{"major":13,"minor":0})
flux.dispatch('version/add',{"major":13,"minor":1})
flux.dispatch('version/add',{"major":13,"minor":8})
flux.dispatch('version/add',{"major":13,"minor":12})
flux.dispatch('version/add',{"major":14,"minor":0,"comments":"**Migrations can take a long time!**"})
flux.dispatch('version/add',{"major":14,"minor":3,"comments":"See [GitLab Issue #354211](https://gitlab.com/gitlab-org/gitlab/-/issues/354211#note_962223568)"})
flux.dispatch('version/add',{"major":14,"minor":9,"comments":"See [GitLab Issue #354211](https://gitlab.com/gitlab-org/gitlab/-/issues/354211#note_962223568)"})
flux.dispatch('version/add',{"major":14,"minor":10})
flux.dispatch('version/add',{"major":15,"minor":0})
flux.dispatch('version/add',{"major":15,"minor":4})
flux.dispatch('version/add',{"major":15,"minor":11})
flux.dispatch('version/add',{"major":16,"minor":3})
flux.dispatch('version/add',{"major":16,"minor":7})
flux.dispatch('version/add',{"major":16,"minor":11})
flux.dispatch('version/add',{"major":17,"minor":1,"comments":"[Conditional stop](https://docs.gitlab.com/ee/update/versions/gitlab_17_changes.html#long-running-pipeline-messages-data-change). Not required by all instances."})
flux.dispatch('version/add',{"major":17,"minor":3})
flux.dispatch('version/add',{"major":17,"minor":5,"comments":"From GitLab 17.5, required upgrade stops consistently land on minor versions X.2, X.5, X.8, and X.11."})
flux.dispatch('version/add',{"major":17,"minor":8})
flux.dispatch('version/add',{"major":17,"minor":11})
flux.dispatch('version/add',{"major":18,"minor":2})
flux.dispatch('version/add',{"major":18,"minor":5})
flux.dispatch('version/add',{"major":18,"minor":8})
flux.dispatch('version/add',{"major":18,"minor":11})
flux.dispatch('version/add',{"major":19,"minor":2})
flux.dispatch('version/add',{"major":19,"minor":5})
flux.dispatch('version/add',{"major":19,"minor":8})
flux.dispatch('version/add',{"major":19,"minor":11})
